export default __webpack_public_path__ + "static/media/logo1.75f5c04c.jpg";